import * as Yup from "yup";

export const PersonAddFormValidation = Yup.object({
  name: Yup.string("نام را وارد کنید").required("نام  را وارد کنید"),
  lastname: Yup.string("نام خانوادگی را وارد کنید").required(
    "نام خانوادگی  را وارد کنید",
  ),
  id_card_number: Yup.number("کد ملی بدون خط تیره وارد کنید"),
  email: Yup.string().email("ایمل وارد نمایید").nullable(),
  credit: Yup.number("عدد وارد نمایید"),
  password: Yup.string(),
  password_repeat: Yup.string().oneOf(
    [Yup.ref("password"), null],
    "کلمه عبور باید یکسان باشد",
  ),
});
